import { render, staticRenderFns } from "./UserNavbarDropdown.vue?vue&type=template&id=334fac21&scoped=true"
import script from "./UserNavbarDropdown.vue?vue&type=script&lang=ts"
export * from "./UserNavbarDropdown.vue?vue&type=script&lang=ts"
import style0 from "./UserNavbarDropdown.vue?vue&type=style&index=0&id=334fac21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334fac21",
  null
  
)

export default component.exports